module.exports = __webpack_public_path__ + "static/img/logo_br.955e63c.png";